import { baseUrl } from './baseUrl';

export const isBlank = (url: string, blank: boolean | undefined) => {
  const domain = new URL(url).hostname;
  const ourDomain = new URL(baseUrl()).hostname;

  if (typeof blank === 'undefined') {
    if (domain !== ourDomain) {
      return true;
    } else {
      return false;
    }
  } else if (blank) {
    return true;
  } else {
    return false;
  }
};
